// Third party and librarys
import React, { useEffect, useState } from 'react'
import { Button, Table, Modal, Form, Card, Row, Col, Spinner } from 'react-bootstrap'
import { useLazyQuery, useMutation } from '@apollo/client'
import _ from 'lodash'

// constants
import { COLOR_WHITE, COLOR_WHITE_200, CREATE_UPDATE_PERMISSINS, DELETED_PERMISSIONS, INLINE_PERMISSIONS, LINEAR_GRADIENT_BG } from '../../../const'
import { CREATE_ROLE_PERMISSION, DELETED_ROLE_PERMISSION, UPDATE_ROLE_PERMISSION } from '../../../apollo/rolePermission/mutation'
import { ReactIcons } from '../../../icons'
import { GET_ROLES } from '../../../apollo/rolePermission/query'
import { successDeleteSwal } from '../../../helper/sweetalert'
import AnimationLoading from '../../../components/Animationloading'

export default function RolePermission() {
    const [roleDatas, setRoleDatas] = useState({
        total: 0,
        data: []
    })
    const [isStatusForm, setIsStatusForm] = useState({
        editMode: false,
        isOpen: false,
        data: null
    });
    const [roleName, setRoleName] = useState('');
    const [note, setNote] = useState('');
    const [permissions, setPermissions] = useState([]);

    // apllo client hooks
    const [createRolePermission, { loading: loadingCreateRole }] = useMutation(CREATE_ROLE_PERMISSION);
    const [updateRolePermission, { loading: loadingUpdateRole }] = useMutation(UPDATE_ROLE_PERMISSION);
    const [deleteRolePermission, { loading: loadingDeleteRole }] = useMutation(DELETED_ROLE_PERMISSION);
    const [getRolePermission, { data: rolePermissionData, loading: loadingGetRole }] = useLazyQuery(GET_ROLES, { fetchPolicy: "network-only" });

    // useEffect hooks
    useEffect(() => {
        if (rolePermissionData) {
            const { total, data } = rolePermissionData?.rolePermissions;
            setRoleDatas({
                total,
                data
            })
        }
    }, [rolePermissionData])

    useEffect(() => {
        fetchRolePermission()
    }, [])

    useEffect(() => {
        if (isStatusForm?.editMode && !_.isEmpty(isStatusForm?.data)) {
            const parsedPermissions = JSON.parse(isStatusForm?.data?.permissions || "[]");
            setRoleName(isStatusForm?.data?.name)
            setNote(isStatusForm?.data?.note)
            setPermissions(parsedPermissions)
        }
    }, [isStatusForm?.editMode])

    // create role permission
    const handleCreateRolePermission = async () => {
        let localData = JSON.parse(localStorage.getItem("SHOP_DATA"))
        try {
            if (loadingCreateRole) return;

            let _data = {
                shop: localData?.id,
                permissions: JSON.stringify(permissions)
            }

            if (!_.isEmpty(roleName)) {
                _data = {
                    ..._data,
                    name: roleName
                }
            }

            if (!_.isEmpty(note)) {
                _data = {
                    ..._data,
                    note
                }
            }

            const res = await createRolePermission({
                variables: {
                    data: _data
                }
            })

            if (res?.data?.createRolePermission?.message) {
                handleClose()
                fetchRolePermission()
            }

        } catch (error) {
            console.log({ error })
        }
    }

    // update role permission data
    const handleUpdateRolePermission = async () => {
        try {
            if (loadingUpdateRole) return;

            let _data = {
                permissions: JSON.stringify(permissions),
                name: roleName,
                note: note
            }

            const res = await updateRolePermission({
                variables: {
                    data: _data,
                    where: {
                        id: isStatusForm?.data?.id
                    }
                }
            })

            if (res?.data?.updateRolePermission?.message) {
                handleClose()
                fetchRolePermission()
            }

        } catch (error) {
            console.log({ error })
        }
    }

    // deleted role permission
    const handleDeleteRolePermission = async (_id) => {
        try {
            if (loadingDeleteRole) return;

            const resDel = await deleteRolePermission({
                variables: {
                    where: {
                        id: _id
                    }
                }
            })

            if (resDel?.data) {
                fetchRolePermission()
                successDeleteSwal("ລົບຂໍ້ມູນສຳເລັດ!")
            }

        } catch (error) {
            console.log({ error })
        }
    }

    // fetch data permissions
    const fetchRolePermission = async () => {
        let localData = JSON.parse(localStorage.getItem("SHOP_DATA"))

        try {
            if (loadingGetRole) return;
            await getRolePermission({
                variables: {
                    where: {
                        shop: localData?.id,
                        isDeleted: false
                    },
                    // skip: null,
                    // limit: null
                }
            })


        } catch (error) {

        }
    }

    // handle change to get value
    const handleCheckboxChange = (value) => {
        setPermissions((prevPermissions) => {
            if (prevPermissions.includes(value)) {
                // If value already exists, remove it
                return prevPermissions.filter((item) => item !== value);
            } else {
                // If value doesn't exist, add it
                return [...prevPermissions, value];
            }
        });
    };

    // Close Modal permission
    const handleClose = () => {
        setPermissions([])
        setRoleName()
        setNote()
        setIsStatusForm({
            editMode: false,
            isOpen: false,
            data: null
        })
    };



    // Handle Full Function Checkbox
    const handleFullFunctionChange = (isChecked) => {
        if (isChecked) {
            // Add all permissions
            const allPermissions = [
                ...INLINE_PERMISSIONS.map((item) => item.value),
                ...CREATE_UPDATE_PERMISSINS.map((item) => item.value),
                ...DELETED_PERMISSIONS.map((item) => item.value)
            ];
            setPermissions(allPermissions);
        } else {
            // Clear permissions
            setPermissions([]);
        }
    };



    return (
        <div style={{ padding: 20 }}>

            <div className='d-flex justify-content-between w-100'>
                <h5>ຈັດການ ບົດບາດ</h5>
                <Button style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }} onClick={() => setIsStatusForm({ isOpen: true })}>
                    <ReactIcons.MdAdd />  ເພີ່ມ
                </Button>
            </div>


            {/* Role Table */}
            <Card style={{ marginTop: 20, minHeight: '80vh' }}>
                {(loadingGetRole) ? <AnimationLoading /> :

                    <Card.Body>
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>ລຳດັບ</th>
                                    <th>ບົດບາດ</th>
                                    <th>ໝາຍເຫດ</th>
                                    <th style={{ textAlign: 'right' }}>ຈັດການ</th>
                                </tr>
                            </thead>
                            <tbody>
                                {roleDatas?.data?.map((role, index) => (
                                    <tr key={role?.id}>
                                        <td>{index + 1}</td>
                                        <td>{role?.name}</td>
                                        <td>{role?.note ?? "-"}</td>
                                        <td align='right'>
                                            <Button variant="warning" size="sm" onClick={() => setIsStatusForm({ editMode: true, isOpen: true, data: role })}><ReactIcons.MdEdit /></Button>
                                            <Button variant="danger" size="sm" onClick={() => handleDeleteRolePermission(role?.id)} style={{ marginLeft: '10px' }}><ReactIcons.MdDeleteOutline /></Button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                }
            </Card>

            {/* Modal for adding new role */}
            <Modal centered show={isStatusForm.isOpen} size="lg">
                <Modal.Header >
                    <Modal.Title style={{ fontWeight: 'bold' }}>{isStatusForm?.editMode ? "ແກ້ໄຂບົດບາດ" : "ເພິ່ມບົດບາດ"}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ overflowY: "auto", padding: "2em", height: '75vh' }} >
                    {/* Role Name Input */}
                    <Row>
                        <Col md={4}>
                            <Form.Group className="mb-3">
                                <Form.Label>ຊື່ບົດບາດ</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="...."
                                    value={roleName}
                                    onChange={(e) => setRoleName(e?.target?.value)}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>ໝາຍເຫດ</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="...."
                                    value={note}
                                    onChange={(e) => setNote(e?.target?.value)}
                                />
                            </Form.Group>

                        </Col>
                    </Row>

                    {/* Tab Navigation */}
                    <div>
                        <div className="custom-checkbox mb-3" style={{ background: COLOR_WHITE_200 }}>
                            <input
                                type="checkbox"
                                id="FULL_FUNCTION"
                                onChange={(e) => handleFullFunctionChange(e.target.checked)}
                                checked={permissions.length === [...INLINE_PERMISSIONS, ...DELETED_PERMISSIONS, ...CREATE_UPDATE_PERMISSINS].length} // Check all if permissions match
                            />
                            <label htmlFor="FULL_FUNCTION">ສາມາດເຂົ້າເຖິງທຸກຢ່າງໃນລະບົບ</label>
                        </div>

                        <br />
                        <p style={{fontWeight:'bold'}}>1. ປະເພດລາຍງານຂໍ້ມູນ</p>
                        {INLINE_PERMISSIONS.map((item, _index) => (
                            <div key={_index} className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    id={`checkbox_${_index}`}
                                    onChange={() => handleCheckboxChange(item.value)}
                                    checked={permissions.includes(item.value)}
                                />
                                <label htmlFor={`checkbox_${_index}`}>{item?.name}</label>
                            </div>
                        ))}
                        <br />
                        <p style={{fontWeight:'bold'}}>2. ປະເພດແກ້ໄຂ ແລະ ເພິ່ມຂໍ້ມູນ</p>
                        {CREATE_UPDATE_PERMISSINS.map((item, _index) => (
                            <div key={_index} className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    id={`checkbox_edit_${_index}`}
                                    onChange={() => handleCheckboxChange(item.value)}
                                    checked={permissions.includes(item.value)}
                                />
                                <label htmlFor={`checkbox_edit_${_index}`}>{item?.name}</label>
                            </div>
                        ))}
                        <br />
                        <p style={{fontWeight:'bold'}}>3. ປະເພດລົບຂໍ້ມູນ</p>   
                        {DELETED_PERMISSIONS.map((item, _index) => (
                            <div key={_index} className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    id={`checkbox_del_${_index}`}
                                    onChange={() => handleCheckboxChange(item.value)}
                                    checked={permissions.includes(item.value)}
                                />
                                <label htmlFor={`checkbox_del_${_index}`}>{item?.name}</label>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" onClick={handleClose}>
                        <ReactIcons.MdCancel />  ຍົກເລີກ
                    </Button>
                    <Button disabled={_.isEmpty(roleName) ? true : false} style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }} onClick={() => {
                        isStatusForm?.editMode ? handleUpdateRolePermission() : handleCreateRolePermission();
                    }}>
                        {(loadingCreateRole || loadingUpdateRole) ? <Spinner size="sm" /> : <ReactIcons.FaCheck />} {isStatusForm?.editMode ? "ຢືນຢັນແກ້ໄຂ" : "ຢືນຢັນ"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
